export const theme = {
  colors: {
    // Brand Colors
    primary: "#2e9694",       // Teal (Main Brand)
    secondary: "#6a8a2c",     // Olive Green (Highlights, Icons)

    // Accent Colors
    accentLight: "#cfe89b",   // Soft Lime (Success / Info)
    accentBlue: "#4a63ff",    // Blue Boxes
    accentBlueDark: "#9063e7", // Fixed: Darker Blue for contrast

    // Neutrals
    dark: "#000000",
    medium: "#4a4a4a",        // Neutral gray for text
    light: "#ffffff",         // General background
    extralight: "#f4f9ef",    // Very light green background

    // Status Colors (Optional)
    success: "#6a8a2c",
    info: "#475dfc",
    warning: "#cfe89b",
  },

  fonts: {
    base: "'Roboto', sans-serif",  // <— UPDATED FONT
    bold: 700,
    semiBold: 600,
    regular: 400,
  },
};
